import { initPageHeader } from "./page-header.js";
import { initHeroScroll } from "./hero.js";
import { initScrollReveal } from "./scroll-reveal.js";

document.addEventListener("DOMContentLoaded", () => {
  initPageHeader();
  initHeroScroll();
  initScrollReveal();
});
